import React, { useEffect, useState } from 'react';
import DataTable, { SortOrder } from 'react-data-table-component';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import DatePicker from "react-datepicker";
import { format, set } from 'date-fns';
export const DepotBasedTopCustomers = ({ }) => {

    const priceFormat = (price) => {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };

    const columns = [
        {
            name: "Account Code",
            selector: row => row.accountCode,
            sortable: false,
        },
        {
            name: "Account Name",
            selector: row => row.accountName,
            sortable: false,
        },

        {
            name: "Date Onboarded",
            selector: row => row.accountCreatedAt,
            sortable: true,
            sortFunction: (a, b) => {
                const dateA = a.accountCreatedAt ? new Date(a.accountCreatedAt).getTime() : -Infinity;
                const dateB = b.accountCreatedAt ? new Date(b.accountCreatedAt).getTime() : -Infinity;
                return dateA - dateB;
            },
            cell: row => {
                if (!row.accountCreatedAt) return '';
                const originalDate = new Date(row.accountCreatedAt);
                const comparisonDate = new Date('2024-09-02');
                const displayDate = originalDate < comparisonDate ? comparisonDate : originalDate;
                return formatDate(displayDate);
            }
        },
        {
            name: "No. of Orders",
            selector: row => row.orderCount,
            sortable: true,
        },
        {
            name: "Ordered Amount",
            selector: row => priceFormat(row.sum),
            sortable: true,
            sortFunction: (a, b) => {
                const totalA = parseFloat(a.sum) || 0;
                const totalB = parseFloat(b.sum) || 0;
                return totalA - totalB;
            },
        },
        {
            name: "Avg. Spent",
            selector: row => priceFormat(row.sum / row.orderCount),
            sortable: true,
            sortFunction: (a, b) => {
                const avgA = parseFloat((a.sum / a.orderCount));
                const avgB = parseFloat((b.sum / b.orderCount));
                return avgA - avgB;
            },
        },
    ];

    const customStyles = {
        rows: {
            style: {
                minHeight: '25px',
            },
        },
        headCells: {
            style: {
                padding: '8px', // override the cell padding for head cells

            },
        },
        cells: {
            style: {
                padding: '8px', // override the cell padding for data cells

            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: "",
        rangeSeparatorText: "",
        selectAllRowsItem: true,
        selectAllRowsItemText: "",
        noRowsPerPage: "",
    };
    const getFiscalMonthNumber = () => {
        const currentMonth = new Date().getMonth(); // 0 = Jan, 1 = Feb, ..., 3 = Apr
        // Fiscal month index: starts from Sep (8), wraps around
        const fiscalIndex = (currentMonth - 8 + 12) % 12;
        const fiscalMonthNumber = ((fiscalIndex + 8) % 12) + 1;
        return fiscalMonthNumber.toString(); // For useState
    };

    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [filter, setFilter] = useState(0);
    const [filtertext, setFilterText] = useState('');
    const [topOrderedCustomers, setTopOrderedCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [FilterType, setFilterType] = useState("revenue");
    const [allCustomers, setAllCustomers] = useState([]); // Store full unfiltered records
    const [months, setMonths] = useState('9');
    const [quarter, setQuarter] = useState('');
    const [mainDepot, setMainDepot] = useState("");
    const [subDepotList, setSubDepotList] = useState([]);
    const [mainDepotList, setMainDepotList] = useState([]);
    const [depots, setDepots] = useState([]);
    const [subDepot, setSubDepot] = useState("");

    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8

    useEffect(() => {

        let URL = BaseUrl + `admin/getdepots`;
        http
            .get(URL)
            .then((response) => {
                let responseData = response.data.data;
                const uniqueDepots = Array.from(new Set(responseData.map(item => item.mainDepot)))
                    .map(mainDepot => responseData.find(item => item.mainDepot === mainDepot));
                setSubDepotList(responseData);
                setDepots(responseData);
                setMainDepotList(uniqueDepots);

            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    useEffect(() => {
        if (mainDepot === "") {
            setSubDepotList(depots);
            setSubDepot("");
        } else {
            setSubDepotList(depots.filter(item => item.mainDepot === mainDepot));
        }

    }, [mainDepot, mainDepotList]);

    const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
    };

    const getFiscalYearRange = (periodStr) => {
        const [start, end] = periodStr.split("-");
        const startDate = new Date(parseInt(start), 8, 1); // Sept 1
        const endDate = new Date(parseInt(end), 7, 31, 23, 59, 59, 999); // Aug 31
        return { startDate, endDate };
    };

    const getQuarterDateRange = (fiscalYearStartYear, quarter) => {
        const fiscalStartMonth = 8; // September
        const quarterIndex = parseInt(quarter) - 1;
        const startMonth = (fiscalStartMonth + quarterIndex * 3) % 12;
        const startYear = fiscalYearStartYear + Math.floor((fiscalStartMonth + quarterIndex * 3) / 12);
        const start = new Date(startYear, startMonth, 1);

        // Adjust end month/year correctly even when wrapping around year-end
        const tempEndMonth = startMonth + 2;
        const endMonth = tempEndMonth % 12;
        const endYear = startYear + Math.floor(tempEndMonth / 12);
        const end = new Date(endYear, endMonth + 1, 0, 23, 59, 59, 999);

        return { start, end };
    };

    const getCurrentFiscalQuarter = () => {
        const month = new Date().getMonth() + 1; // 1–12
        if (month >= 9 && month <= 11) return 1;   // Sep–Nov
        if (month === 12 || month <= 2) return 2;  // Dec–Feb
        if (month >= 3 && month <= 5) return 3;    // Mar–May
        return 4;                                  // Jun–Aug
    };

    const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => {
                if (selectedFiscalYear === currentFiscalYear) {
                    return Number(quarterNumber) <= currentQuarter;
                }
                return true; // show all for past years
            })
            .map(([quarterNumber, label]) => (
                <option key={quarterNumber} value={quarterNumber}>
                    {label}
                </option>
            ));
    };
    useEffect(() => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const fiscalQuarterMap = {
            9: 1, 10: 1, 11: 1,
            12: 2, 1: 2, 2: 2,
            3: 3, 4: 3, 5: 3,
            6: 4, 7: 4, 8: 4
        };
        const currentFiscalQuarter = fiscalQuarterMap[month];
        setQuarter(currentFiscalQuarter);
    }, []);

    useEffect(() => {
        if (FilterType === "dateOnboarded") return;
        if (filter === "custom" && (!fromDate || !toDate)) {
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }
         setIsLoading(true);
        let payload = {};
        if (filter === 'custom') {
            payload = {
                filter: filter, datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                dateto: format(new Date(toDate), "yyyy-MM-dd"),
                mainDepot: mainDepot,
                subDepot: subDepot,
            }
            setShowDatePicker(false);
        }
        else if (["weekly", "monthly", "quarterly", "FYdata"].includes(filter)) {
            payload = {
                filter: filter,
                datefrom: "",
                dateto: "",
                period: period,
                mainDepot: mainDepot,
                subDepot: subDepot,
            };
        }
        else {
            payload = {
                filter: parseInt(filter), datefrom: '',
                dateto: '',
                mainDepot: mainDepot,
                subDepot: subDepot,
                // FilterType: FilterType
            }
        }
        let URL2 = BaseUrl + "admin/depottopcustomers";
        http.post(URL2, payload).then((response) => {
            setIsLoading(false);
            const data = response.data.data.filter((item) => item.sum > 0);
            const updatedData = data.map((item) => {
                if (item.accountCreatedAt) {
                    const originalDate = new Date(item.accountCreatedAt);
                    const comparisonDate = new Date('2024-09-02');
                    // Change the date if it's before 02/09/2024
                    if (originalDate < comparisonDate) {
                        item.accountCreatedAt = comparisonDate.toISOString();
                    }
                }
                return item;
            });

            const actualMonth = parseInt(months);

            const updatedData1 = (filter === 'monthly') ? updatedData.filter(
                item => item.month === actualMonth
            ) : (filter === 'quarterly') ? updatedData.filter(
                item => item.quarter === quarter) : updatedData;
            if (allCustomers.length === 0) {
                setAllCustomers(updatedData1);
            }
            setTopOrderedCustomers(updatedData1.filter(item => {
                if (mainDepot && subDepot) {
                    return item.mainDepot === mainDepot && item.subDepot === subDepot;
                } else if (mainDepot) {
                    return item.mainDepot === mainDepot;
                } else if (subDepot) {
                    return item.subDepot === subDepot;
                }
                return true; // No filter applied
            }));
        }).catch((err) => {
             setIsLoading(false);
            console.log(err);
        })

    }, [filter, fromDate, toDate, FilterType, months, quarter, period, mainDepot, subDepot]);

    useEffect(() => {
        if (FilterType === "dateOnboarded") {
             setIsLoading(true);
            // Convert all valid dates into Date objects
            let filteredData = allCustomers
                .filter(c => c.accountCreatedAt) // Ignore records without accountCeatdAt 
                .map(c => ({
                    ...c,
                    accountCreatedAt: new Date(c.accountCreatedAt) // Convert to Date object
                }))
                .filter(c => !isNaN(c.accountCreatedAt.getTime())); // Remove invalid dates

            if (parseInt(filter, 10) === 0) {
                setTopOrderedCustomers(filteredData);
                setIsLoading(false); 
                return;
            }

            const today = new Date();
            today.setUTCHours(0, 0, 0, 0); // Remove time part for date comparison

            const pastDays = parseInt(filter, 10);

            if (!isNaN(pastDays) && pastDays > 0) {
                const pastDate = new Date(today);
                pastDate.setDate(today.getDate() - pastDays);

                filteredData = filteredData.filter(item => {
                    return item.accountCreatedAt >= pastDate;
                });
            }
            else if (filter === "custom" && fromDate && toDate) {
                const parseDate = (date) => {
                    if (date instanceof Date) return date; // If already a Date object, return it
                    if (typeof date === "string" && date.includes("/")) {
                        // Convert DD/MM/YYYY or MM/DD/YYYY to Date
                        const parts = date.split("/");
                        return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                    }
                    return new Date(date); // Attempt standard conversion
                };

                const fromParsed = parseDate(fromDate);
                const toParsed = parseDate(toDate);
                toParsed.setHours(23, 59, 59, 999);

                filteredData = filteredData.filter(item => {
                    const recordDate = parseDate(item.accountCreatedAt);
                    return recordDate >= fromParsed && recordDate <= toParsed;
                });
            }
            else if (filter === "weekly") {
                const day = today.getDay();
                const mondayOffset = day === 0 ? -6 : 1 - day; // make Monday the first day
                const startOfWeek = new Date(today);
                startOfWeek.setDate(today.getDate() + mondayOffset);
                const endOfWeek = new Date(startOfWeek);
                endOfWeek.setDate(startOfWeek.getDate() + 6);
                endOfWeek.setHours(23, 59, 59, 999);
                filteredData = filteredData.filter(item =>
                    item.accountCreatedAt >= startOfWeek && item.accountCreatedAt <= endOfWeek
                );
            }
            else if (["monthly", "quarterly", "FYdata"].includes(filter)) {
                //const period = period.split("-");
                const { startDate, endDate } = getFiscalYearRange(period);

                if (filter === "monthly") {
                    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
                    const fiscalStartYear = parseInt(period.split("-")[0]); // "2024-2025" → 2024
                    const selectedMonthNumber = parseInt(months); // e.g., '9' → 9
                    const selectedMonthIndex = (selectedMonthNumber + 3) % 12; // maps 9 (Sep) → index 0, 10 → 1, ..., 8 (Aug) → 11

                    const actualMonth = (selectedMonthIndex + 8) % 12; // JS month index (0-11)
                    const actualYear = selectedMonthIndex <= 3 // Sep–Dec = same fiscal year
                        ? fiscalStartYear
                        : fiscalStartYear + 1;

                    const start = new Date(actualYear, actualMonth, 1);
                    const end = new Date(actualYear, actualMonth + 1, 0, 23, 59, 59, 999);

                    filteredData = filteredData.filter(item =>
                        new Date(item.accountCreatedAt) >= start &&
                        new Date(item.accountCreatedAt) <= end
                    );
                }
                else if (filter === "quarterly") {
                    const { start, end } = getQuarterDateRange(parseInt(period.split("-")[0]), quarter);
                    filteredData = filteredData.filter(item =>
                        item.accountCreatedAt >= start && item.accountCreatedAt <= end
                    );
                }
                else if (filter === "FYdata") {
                    filteredData = filteredData.filter(item =>
                        item.accountCreatedAt >= startDate && item.accountCreatedAt <= endDate
                    );
                }
            }
            setTopOrderedCustomers(filteredData);
            setIsLoading(false);
        }
    }, [FilterType, filter, allCustomers, fromDate, toDate, months, quarter, period, mainDepot, subDepot]);

    const changeFilterHandler = (e) => {

        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === 'custom') {
            setShowDatePicker(true);

        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);

        }
    };

    const changeMainDepotHandler = (e) => {
        setSubDepot("");
        setMainDepot(e.target.value);

    }
    const changeSubDepotHandler = (e) => {
        setSubDepot(e.target.value);
    }

const changePeriodHandler = (e) => {
  const newPeriod = e.target.value;
  setPeriod(newPeriod); // update selected fiscal year in state
  //split fiscal year
  const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);
  
  const fiscalStartMonthIndex = 8; // 0-based index for September

  const today = new Date();
  const currentFiscalYear = getCurrentFiscalYear();
  //compare sleted year with currentfiscalyear 
  const isCurrentFiscalYear = newPeriod === currentFiscalYear;

  // MONTHLY filter logic
  if (filter === 'monthly') {
    let visibleMonthNames = MonthNames;

    if (isCurrentFiscalYear) {
      // Calculate current fiscal month index 
      const currentMonthIndex = today.getMonth(); // 0-based
      const monthsPassedSinceFiscalStart =
        (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
      const maxVisibleIndex = monthsPassedSinceFiscalStart;

      visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
    }

    const selectedMonthIndex = MonthNames.indexOf(months);
    const isValidMonth =
      selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;

    if (!isValidMonth) {
      const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
      setMonths(String(defaultMonthNumber));
    }
  }

  // QUARTERLY filter logic
  if (filter === 'quarterly') {
    const currentQuarter = getCurrentFiscalQuarter();
    let maxQuarter = 4;

    if (isCurrentFiscalYear) {
      maxQuarter = currentQuarter;
    }

if (parseInt(quarter) > maxQuarter) {
  setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
}

  }
};

    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };

    const changeFilterTypeHandler = (e) => {
        setFilterType(e.target.value);
    };

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }

    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };

    // Calculate dynamic pagination options
    const calculatePaginationOptions = (totalRecords, interval) => {
        const options = [];
        for (let i = interval; i <= totalRecords; i += interval) {
            options.push(i);
        }
        return options;
    };

    const totalRecords = topOrderedCustomers.length; // Get the total records count
    const totalRevenue = topOrderedCustomers.reduce((acc, customer) => acc + (customer.sum || 0), 0);
    const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
        }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
    let loadingbuffer = isLoading ? 'loading-buffer' : '';
    return (
        <div className={`chart-container chart-high-customers ${loadingbuffer}`} style={{ verticalAlign: "top" }}>
            <div className="chart-Hdr">
                <div className="chart-Hdr-txt">
                    <h2>Depot-Based High-Value Customers</h2>
                </div>
                {/* New Sort Filter Dropdown */}
                <div className="chart-fltr-Hldr">
                    <div className="chart-fltr">
                        {<select name="mainDepot" value={mainDepot} onChange={(e) => changeMainDepotHandler(e)}>
                            <option value="">Select Main Depot</option>
                            {mainDepotList.map(item => (
                                <option key={item.mainDepot} value={item.mainDepot}>{item.mainDepot}</option>
                            ))}
                        </select>}
                    </div>
                    <div className="chart-fltr">
                        {<select name="subDepot" value={subDepot} onChange={(e) => changeSubDepotHandler(e)}>
                            <option value="">Select Local Depot</option>
                            {subDepotList.map(item => (
                                <option key={item.subDepot} value={item.subDepot}>{item.subDepot}</option>
                            ))}
                        </select>}
                    </div>

                    <div className="chart-fltr">
                        <select value={FilterType} onChange={(e) => changeFilterTypeHandler(e)}>
                            <option value="revenue">Revenue</option>
                            <option value="dateOnboarded">Date Onboarded</option>
                        </select>
                    </div>

                    <div className="chart-fltr" onMouseEnter={() => {
                        if (filter === "custom" && !showDatePicker) {
                            setShowDatePicker(true);
                        }
                    }}
                        onMouseLeave={() => {
                            if (filter === "custom" && showDatePicker) {
                                setShowDatePicker(false);

                            }
                        }}>
                        {<select
                            value={filter}
                            onChange={(e) => changeFilterHandler(e)}
                        ><option value={0}>All</option>
                            <option value={"weekly"}>Current Week</option>
                            <option value={"monthly"}>Monthly</option>
                            <option value={"quarterly"}>Quarterly</option>
                            <option value={"FYdata"}>FY Data</option>
                            <option value={30}>Past 30 Days</option>
                            <option value={90}>Past 90 Days</option>
                            <option value={180}>Past 180 Days</option>
                            <option value={365}>Past 1 Year</option>
                            <option value={'custom'}>Custom Date</option>
                        </select>}
                        {showDatePicker && (
                            <div className="date-picker-container">
                                <label>From:</label>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => DateChange(date, "from")}
                                    showDisabledMonthNavigation
                                    dateFormat="dd/MM/yyyy"
                                    disablePast={true}
                                    maxDate={new Date()}
                                    placeholderText="Select Date"
                                />
                                <label>To:</label>
                                <DatePicker
                                    selected={toDate}
                                    showDisabledMonthNavigation
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => DateChange(date, "to")}
                                    disablePast={true}
                                    maxDate={new Date()}
                                    placeholderText="Select Date"
                                />
                            </div>
                        )}
                        {filter === 'quarterly' && (
                            <select
                                style={{ width: "160px" }}
                                value={quarter}
                                onChange={(e) => setQuarter(Number(e.target.value))}
                            >
                                {/* {Object.entries(quarterNames).map(([q, label]) => (
                        <option key={q} value={q}>{label}</option>
                        ))} */}
                                {getAvailableQuarters(period)}
                            </select>
                        )}

                        {filter === 'monthly' && <select style={{  }} value={months} onChange={(e) => changeMonthHandler(e)}>
                            {visibleMonthNames.map((monthName, index) => {
                                const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                                return (
                                    <option key={monthNumber} value={monthNumber}>
                                        {monthName}
                                    </option>
                                );
                            })}
                        </select>

                        }
                        {(filter === 'monthly' || filter === 'quarterly' || filter === 'FYdata') && <select
                            style={{ width: "170px" }}
                            value={period}
                            onChange={(e) => changePeriodHandler(e)}
                        >
                            {options}
                        </select>}
                    </div>
                </div>
                <div className="fltr-sub-val">
                    {topOrderedCustomers.length > 0 && (<span className='fltr-val'>Total Records: <strong>{topOrderedCustomers.length}</strong> / Total Revenue: <strong>{priceFormat(topOrderedCustomers.reduce((acc, customer) => acc + (customer.sum || 0), 0))} </strong>{(["Current Week", "Monthly", "Quarterly", 'FY Data'].includes(filtertext)) ? '' : (filtertext != '' && filtertext != 'Custom Date') ? ' (' + filtertext + ')' : (filtertext === 'Custom Date' && fromDate && toDate) ? ' (' + formatDate(fromDate) + ' - ' + formatDate(toDate) + ')' : ' (' + 'All' + ')'}</span>)}
                </div>
            </div>
            <DataTable
                columns={columns}
                data={topOrderedCustomers}
                customStyles={customStyles}
                noDataComponent={<div className='no-records-found'>Sorry, no data found for your filtered search.</div>}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                //paginationRowsPerPageOptions={paginationOptions}
                paginationComponentOptions={paginationComponentOptions}
            // paginationComponentOptions={{
            //     rowsPerPageText: '', // Hides "Rows per page"
            // }}
            />
        </div>
    );
};